<!--
 * @Author: weijinpeng jinpeng.wei@ctx.sg
 * @LastEditors: weijinpeng jinpeng.wei@ctx.sg
 * @Date: 2023-03-03 14:26:02
 * @LastEditTime: 2023-03-10 15:49:09
 * @Description: 
-->
<template>
    <div>
        <div v-if="!viewBool">
            <!-- 标题 -->
            <div class="title">Retirement Request with Approval Action Pending</div>

            <!-- 搜索 -->
            <div class="search">
                <el-row :gutter="20" type="flex" align="bottom">
                    <el-col :span="8">
                        <div class="search_t">User Name</div>
                        <el-input v-model="fromData.operator" clearable placeholder="User Name"></el-input>
                    </el-col>
                    <el-col :span="8">
                        <div class="search_t">Status</div>
                        <el-select v-model="fromData.status" style="width:100%" clearable  placeholder="All">
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="8">
                        <div class="search_btn">Search</div>
                    </el-col>
                </el-row>
            </div>

            <!-- 表格 -->
            <div class="mg_t_40">
                <el-table
                    :data="tableData.slice((currentPage - 1) * pageSize,currentPage * pageSize)"
                    stripe
                    :cell-style="columnStyle"
                    style="width: 920px"
                    :header-cell-style="{
                    background: '#F0F3F6',
                    color: '#626262',
                    fontSize: '12px',
                    paddingTop: '17px',
                    paddingBottom: '15px',
                    }"
                >
                    <!-- 空状态 -->
                    <template slot="empty">
                    <p style="margin-top: 50px">
                        <img class="data-pic" src="../../assets/img/noData.png" alt=""/>
                    </p>
                    </template>
                    <el-table-column prop="userName" width="100" label="User Name"></el-table-column>
                    <el-table-column prop="status" width="130" label="Status"></el-table-column>
                    <el-table-column prop="requestTime" width="130" label="Request Time"></el-table-column>
                    <el-table-column prop="updateTime" width="130" label="Update Time"></el-table-column>
                    <el-table-column prop="quantity" width="230" label="Carbon Credits Quantity"></el-table-column>
                    <el-table-column fixed="right" width="300" label="Action">
                        <template  slot-scope="scope">
                            <div class="tb_box">
                                <div class="view txt" @click="changeViewBool">View</div>
                                <div class="Approve txt" v-if="!scope.row.isBool">Approve</div>
                                <div class="Reject txt" v-if="!scope.row.isBool">Reject</div>
                                <div class="Cancell txt" v-if="scope.row.isBool">Cancel</div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="display_flex" style="margin-top: 47px">
                    <el-pagination
                    v-if="tableData.length != 0"
                    @current-change="handleCurrentChange"
                    :page-size="pageSize"
                    background
                    layout="prev, pager, next"
                    class="pagination"
                    prev-text="<"
                    next-text=">"
                    :total="tableData.length"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>

        <div v-if="viewBool == 1">
            <!-- International Carbon Credit Quantity: -->
            <!-- <div class="top">
                <div class="top_h3">International Carbon Credit Quantity:</div>
                <div class="top_h2">10,000</div>
            </div> -->

            <!-- Retirement Request -->
            <div class="d_t">Retirement Request Record</div>


            <!-- 表格 -->
            <div class="mg_t_50">
                <el-table
                    :data="tableData1"
                    stripe
                    :cell-style="columnStyle"
                    style="width: 100%"
                    :header-cell-style="{
                    background: '#F0F3F6',
                    color: '#626262',
                    fontSize: '12px',
                    paddingTop: '17px',
                    paddingBottom: '15px',
                    }"
                >
                    <!-- 空状态 -->
                    <template slot="empty">
                    <p style="margin-top: 50px">
                        <img class="data-pic" src="../../assets/img/noData.png" alt=""/>
                    </p>
                    </template>
                    <el-table-column prop="projectId" label="Project ID">
                        <template  slot-scope="scope">
                            <div class="view" @click="gotoDetail(scope.row)">{{scope.row.projectId}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="projectName" label="Project Name">
                        <template  slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.projectName" placement="bottom">
                                <div class="t_txt w_130">{{ scope.row.projectName }}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="vintage" label="Vintage"></el-table-column>
                    <el-table-column prop="region" label="Geographical Source">
                        <template  slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.region" placement="bottom">
                                <div class="t_txt w_130">{{ scope.row.region }}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="quantity" width="230" label="Retire Quantity"></el-table-column>
                    
                </el-table>
                <div class="tb_btm">Total Apply Quantity:7000</div>
            </div>

            <!-- Upload Document -->
            <div class="tb_2">
                <div class="h2">Document List</div>
            </div>

            <!-- 表格 -->
            <div class="mg_t_50">
                <el-table
                    :data="tableData2"
                    stripe
                    :cell-style="columnStyle"
                    style="width: 100%"
                    :header-cell-style="{
                    background: '#F0F3F6',
                    color: '#626262',
                    fontSize: '12px',
                    paddingTop: '17px',
                    paddingBottom: '15px',
                    }"
                >
                    <!-- 空状态 -->
                    <template slot="empty">
                    <p style="margin-top: 50px">
                        <img class="data-pic" src="../../assets/img/noData.png" alt=""/>
                    </p>
                    </template>
                    <el-table-column prop="documentType" label="Document Type"></el-table-column>
                    <el-table-column prop="documentName" label="Document Name"></el-table-column>
                    <el-table-column prop="description" label="Document Description"></el-table-column>
                    <el-table-column label="Action" width="100px">
                        <template slot-scope="scope">
                                <div class="Download_btn_r" @click="Download">Download</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="btm_btn">
                <div class="flex">
                    <div class="can_btn" @click="cancelRequestBool">Back</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  
export default {
    name: 'carbon2',
    components: {},
    data(){
      return {
        fromData:{
            operator:"",
            status:"",
            date:"",
            projectId:'',
        },
        statusList:[
            {
                value: '1',
                label: 'Pending'
            },
            {
                value: '2',
                label: 'Approved'
            },
        ],
        tableData:[
            {
                userName:'Ellen',
                status:'Pending',
                requestTime:"2022/12/21",
                updateTime:"2022/12/21",
                quantity:'7000',
                isBool:false,
            },
            {
                userName:'Amber',
                status:'Approved',
                requestTime:"2022/12/21",
                updateTime:"2022/12/21",
                quantity:'7000',
                isBool:true,
            }
        ],
        tableData1:[
            {
                projectId:'43456',
                projectName:"Qingfeng Biogas Recovery and Utilization Project",
                vintage:"2021/12-2022/12",
                region:"China",
                quantity:"7000"
            }
        ],
        tableData2:[
            {
                documentType:'Draft project description document (PDD)',
                documentName:'MVGX-Draft PDD',
                description:'Description',
            }
        ],
        viewBool:0,
        upload_dia:false,
        pageSize: 10,
        currentPage: 1,
      }
    },
    mounted(){},
    methods:{
        columnStyle({ row, column, rowIndex, columnIndex}){
            if(columnIndex == 1){
                return "color:#366F67;word-break:break-word;";
            }
            return "word-break:break-word;";
        },
        //翻页
        handleCurrentChange(updateCurrentPage) {
            this.currentPage = updateCurrentPage;
        },
        gotoDetail(row){
          this.$router.push({ path: "/carbonDetail2", query: { id: row.projectId } });
        },
        Download(){
            window.location.href='/api/file/download'
        },
        changeViewBool(){
            this.viewBool = 1
        },
        cancelRequestBool(){
            this.viewBool = 0
        },
        confirmRequestBool(){
            this.viewBool = 0
        },
    },
}
</script>

<style lang="scss" scoped>
.title{
  font-size: 30px;
  font-family: Arial-BoldMT, Arial;
  font-weight: 600;
  color: #1E1E1E;
  line-height: 34px;
}
.mg_t_40{
  margin-top:40px;
}
.search{
    margin-top:50px;
    .search_t{
        font-size: 14px;
        font-weight: 600;
        color: #21212B;
        line-height: 16px;
        margin-bottom:10px;
    }
    .search_btn{
        width: 130px;
        height: 38px;
        border-radius: 8px;
        border: 1px solid #158869;
        font-size: 16px;
        color: #158869;
        line-height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
}
.display_flex{
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.view{
    color:#013C89;
    cursor: pointer;
}
.tb_box{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .txt{
    font-size: 16px;
    font-family: ArialMT;
    margin-right: 15px;
    cursor: pointer;
  }
  
  .Approve{
    color:#158869;
  }
  .Reject{
    color:#ED6666;
  }
  .Cancell{
    color:rgba(0,20,42,0.65);
  }
}

.top{
    width: calc(100% - 60px);
    height: 80px;
    background: #e1eeeb;
    border-radius: 8px;
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .top_h3{
        font-size: 16px;
        color: #626262;
        line-height: 18px;
    }
    .top_h2{
        font-size: 30px;
        font-weight: 600;
        color: #000000;
        line-height: 34px;
    }
}
.d_t{
    font-size: 30px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 34px;
    margin-top:50px;
}
.mg_t_50{
    margin-top: 50px;
}
.Download_btn_r{
    font-size: 16px;
    font-family: ArialMT;
    color: #158869;
    line-height: 18px;
    cursor: pointer;
}
.btm_btn{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top:50px;
    .flex{
        display: flex;
        align-items: center;
        .can_btn{
            width: 110px;
            height: 38px;
            border-radius: 8px;
            border: 1px solid #158869;
            font-size: 16px;
            font-family: ArialMT;
            color: #158869;
            line-height: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }
        .con_btn{
            width: 110px;
            height: 40px;
            background: #158869;
            border-radius: 8px;
            font-size: 16px;
            font-family: ArialMT;
            color: #FFFFFF;
            line-height: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 20px;
            cursor: pointer;
        }
    }
}
.tb_btm{
    width: calc(100% - 40px);
    height: 50px;
    background: #FFFFFF;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding:0 20px;
    font-size: 20px;
    font-family: Arial-BoldMT, Arial;
    font-weight: 600;
    color: #1E1E1E;
    line-height: 23px;
}
.tb_2{
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .h2{
        font-size: 30px;
        font-family: Arial-BoldMT, Arial;
        font-weight: 600;
        color: #1E1E1E;
        line-height: 34px;
    }
    .felx{
        display: flex;
        align-items: center;
        cursor: pointer;
        .img{
            width:20px;
            height:20px;
        }
        .h3{
            font-size: 14px;
            font-family: ArialMT;
            color: #158869;
            line-height: 16px;
            margin-left: 8px;
        }
    }
}
.t_txt{
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.w_130{
    max-width: 130px;
}
.w_100{
    max-width: 100px;
}
.w_120{
    max-width: 120px;
}
</style>
  